import { render, staticRenderFns } from "./PagesAdd.vue?vue&type=template&id=71890de2"
import script from "./PagesAdd.vue?vue&type=script&lang=js"
export * from "./PagesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports